module.exports = __webpack_public_path__ + "assets/images/logo.png";


//////////////////
// WEBPACK FOOTER
// ./app/common/navbar/left/images/logo.png
// module id = 2ncJ
// module chunks = 1